export default {
  // 工作详情」全新升级，简洁更高效
  WORK_DETAIL_NEW: '/update-notes/work-pane-updates',
  // 飞书集成
  SETTING_INTEGRATION_LARK: '',
  // LigaAI-飞书应用使用方法
  SETTING_INTEGRATION_LARK_USED: '',
  //消息通知learn more
  SETTING_NOTIFICATION_LEARN_MORE: '/personal/notifications',
  // 邮件集成
  SETTING_EMAIL_INTEGRATION: '/tools/apps/email-integration',
  // SLACK集成配置方法
  SETTING_INTEGRATION_LARK_CFG: '/tools/communicate/slack-integration',
  // SLACK集成 视频
  SETTING_INTEGRATION_LARK_VIDEO: '/tools/communicate/slack-integration',
  // Jenkins集成使用说明
  SETTING_INTEGRATION_JENKINS: '/tools/develop/jenkins',
  // Jenkins配置方法
  SETTING_INTEGRATION_JENKINS_CONFIG: '/tools/develop/jenkins/how-to-integrate-with-jenkins',
  // LigaAI-企业微信应用使用方法
  SETTING_INTEGRATION_WECOM: '',
  // Jira导入
  SETTING_INTEGRATION_JIRA_IMPORT: '/tools/apps/import-work-from-jira',
  // Jetbrains系列插件安装与使用说明
  PLUGINS_JETBRAINS: '/ide-plugin/leiga-for-ides/leiga-jetbrains-plugins',
  // VS Code 插件安装与使用说明
  PLUGINS_VSCODE: '/ide-plugin/leiga-for-ides/leiga-visual-studio-code-extension',
  // IDE插件安装与使用说明
  PLUGINS_IDE: '/ide-plugin/leiga-for-ides',
  // 「智能助理」介绍
  PROJECT_AUTOMATION: '/project/automation',
  // 「智能助理」dev ops
  PROJECT_AUTOMATION_DEV_OPS: '/project/automation/template/devops',
  // 「智能助理」缺陷管理
  PROJECT_AUTOMATION_DEFECT_MANAGEMENT: '/project/automation/template/bug-tracking',
  // Webhook配置
  PROJECT_WEBHOOK: '/project/settings/webhook',
  // 机器人配置-企业微信
  PROJECT_WEBHOOK_WECOM: '',
  // 机器人配置-钉钉
  PROJECT_WEBHOOK_DING_TALK: '',
  // 机器人配置-飞书
  PROJECT_WEBHOOK_LARK: '',
  // Teams webhook配置
  PROJECT_WEBHOOK_TEAMS: '/project/settings/webhook',
  // webhook 自定义变量
  PROJECT_WEBHOOK_VARIABLE: '',
  // 组件
  DASHBOARD_WIDGET: '/cross-project/dashboard/assembly',
  // 邀请成员加入组织
  MEMBER_INVITE_TEAM: '/organization/member/invite',
  // LigaAI 更新记录
  SYSTEM_CHANGE_LOG: '/update-notes/whats-new',
  // 导航结构焕新升级，更高效、更流畅、更直观
  SYSTEM_NAV_UPDATE: '',
  // 全新UI升级，更易用、高效、美观
  SYSTEM_UI_UPDATE: '',
  // 导入工作-如何操作
  IMPORT_WORK_HOW_TO_USE: '/project/work/import-work-items',
  // Gitlab集成功能的使用
  GITLAB_HOW_TO_USE: '/tools/develop/gitlab-integration#view-build-information-in-leiga',
  // 导入评论-如何操作
  IMPORT_COMMENT_HOW_TO_USE: '/project/work/import-work-items/import-comments',
  // 效能--了解更多
  EFFICIENCY_LEARN_MORE: '/cross-project/performance',
  //风险预警
  RISK_WARNING: '/leiga-lab/ai-risk-alert',
  //indexedDB
  INDEXEDDB: '/leiga-lab/indexeddb',
  //价值触达
  VALUE: '/leiga-lab/leiga-weekly-report',
  SCREEN_RECORD: '/project/screen-record',
  LARK_INTEGRATION_FEATURES: ''
};
// https://docs.leiga.com/tools/develop/Jenkins
// https://docs.leiga.com/tools/develop/jenkins?t=5648626167aef22c1d29.1662535750416
